// extracted by mini-css-extract-plugin
module.exports = {"propertyConsultationsTable":"propertyConsultations_propertyConsultationsTable__fPAgI"};